import Model from '@/models/Model'

export default {
    mixins: [
        Model
    ],

    data() {
        return {
            table: 'guarantees',
            name: 'guarantee',
            class: 'Modules\\Site\\Entities\\Guarantee'
        }
    }
}